import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];

const STEPS = [
  {
    n: "01",
    title: "Tell us what you need",
    desc: "Describe your project: the service, your location, budget range, photos, and whether it's an emergency. It takes a few minutes and is completely free.",
  },
  {
    n: "02",
    title: "Get matched with local pros",
    desc: "Your request reaches professionals who actually serve your city and ZIP code — not a national call center. Emergency requests are flagged as urgent.",
  },
  {
    n: "03",
    title: "Compare offers & choose",
    desc: "Review each professional's offer, profile, and estimate method — phone, email, or on-site. Pick your preferred appointment time.",
  },
  {
    n: "04",
    title: "Book and get it done",
    desc: "Confirm your appointment, message your pro directly, and track your project from request to completion.",
  },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="relative bg-navy grain py-24 lg:py-32 overflow-hidden">
    <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-10">
      <p className="uppercase tracking-[0.25em] text-flame font-heading font-bold text-sm mb-4">02 — The Process</p>
      <h2 data-testid="how-it-works-heading" className="font-heading font-black tracking-tighter text-white text-3xl sm:text-4xl lg:text-5xl mb-20">
        How Prime Pro works
      </h2>

      <div className="space-y-20">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            data-testid={`how-step-${s.n}`}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, delay: 0.1, ease }}
            className="relative pl-8 md:pl-0"
          >
            <span className="absolute -top-10 -left-2 md:-left-16 font-heading font-black text-8xl lg:text-9xl text-white/5 select-none leading-none">
              {s.n}
            </span>
            <div className="relative border-l-2 border-flame pl-8 py-2">
              <h3 className="font-heading font-black tracking-tight text-white text-2xl lg:text-3xl">{s.title}</h3>
              <p className="text-white/60 mt-4 max-w-2xl text-base leading-relaxed">{s.desc}</p>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8, delay: 0.3 }}
        className="mt-20 text-white/40 text-sm border-t border-white/10 pt-8 max-w-2xl"
      >
        No fake reviews. No inflated numbers. Professionals only display badges — licensed,
        insured, verified — after our team confirms the documentation.
      </motion.p>
    </div>
  </section>
);

export default HowItWorks;
